import React from 'react';
import { useSelector } from 'react-redux';
import { message } from 'antd';

import { useSubmitPerpetualMasses } from '../../../api/actions/useSubmitPerpetualMasses';
import selectors from '../../../store/selectors';
import { PerpetualMassesForm } from '../PerpetualMassesForm/PerpetualMassesForm';
import { perpetualMassFormNames } from '../PerpetualMassesForm/perpetualMassFormNames';

export const formatValues = values => {
  return {
    donator_name: values[perpetualMassFormNames.fullName],
    donator_email: values[perpetualMassFormNames.email],
    donator_phone: values[perpetualMassFormNames.phone],
    offering_type: values[perpetualMassFormNames.offeringType],
    offering_content: values[perpetualMassFormNames.offeringContent],
    offering_amount: values[perpetualMassFormNames.offeringAmount],
    ...(values[perpetualMassFormNames.showAddress] && {
      offering_delivery_address: {
        country: values[perpetualMassFormNames.country],
        city: values[perpetualMassFormNames.city],
        zip_code: values[perpetualMassFormNames.zipCode],
        street: values[perpetualMassFormNames.street],
      },
    }),
  };
};

export const AddPerpetualMass = () => {
  const { loading, mutate } = useSubmitPerpetualMasses();

  const accountId = useSelector(selectors.getAccountId);

  const onSubmit = async values => {
    const { error, payload } = await mutate({
      accountId,
      formValues: formatValues(values),
    });

    if (error) {
      message.error('Wystąpił problem połączenia. Odśwież stronę i spróbuj ponownie', 8);
    } else {
      // eslint-disable-next-line no-restricted-globals
      location.href = payload.tpayLink;
    }
  };

  return <PerpetualMassesForm onSubmit={onSubmit} loading={loading} />;
};

AddPerpetualMass.propTypes = {};
